import { selectHeader } from "../../common";
export var selectHeaderLayout = function selectHeaderLayout(state) {
  return selectHeader(state).layout || {};
};
export var selectHeaderTheme = function selectHeaderTheme(state) {
  return selectHeaderLayout(state).theme;
};
export var selectIsWebView = function selectIsWebView(state) {
  return selectHeaderLayout(state).isWebView;
};
export var selectIsRegionConfirmationShow = function selectIsRegionConfirmationShow(state) {
  return selectHeaderLayout(state).isRegionConfirmationShow;
};